import React, { Component } from "react";
import { connect } from "react-redux";
import Input, { InputLabel } from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import { FormControl } from "material-ui/Form";
import Select from "material-ui/Select";
import {
  addSelectedTag,
  removeSelectedTag,
  changeSelectedTags
} from "../../modules/units";
import "./TagSelector.css";
import { bindActionCreators } from "redux";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

class TagSelector extends Component {
  state = {
    name: []
  };

  handleChange = event => {
    let tags = event.target.value;
    this.props.changeSelectedTags(tags);
  };
  render() {
    return (
      <div className="tag-selector">
        <FormControl className="form-control">
          <InputLabel htmlFor="select-multiple">Etiquetas</InputLabel>
          <Select
            multiple
            value={this.props.selectedTags}
            onChange={this.handleChange}
            input={<Input id="select-multiple" />}
          >
            {this.props.tags.map(tag => (
              <MenuItem key={tag} value={tag}>
                {tag}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    tags: state.units.tags,
    selectedTags: state.units.selectedTags
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      addSelectedTag,
      removeSelectedTag,
      changeSelectedTags
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TagSelector);



// WEBPACK FOOTER //
// ./src/components/TagSelector/TagSelector.js